import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {getPluginName, namesEqual} from '@packages/systems/wfdl-Qualified';
import {pageComponentType} from '@packages/utilities/platform';

/**
 * Determines if element is a user component instance
 *
 * We avoid passing `componentMap` into `analyzeElement` by using this weak
 * approach to testing if `element` is a user component instance. `componentMap`
 * changes often, and it always breaks memoization even when the changes don't
 * affect the `element` tree being analyzed.
 *
 * @param element
 * @returns {boolean}
 */
export function isUserComponentInst(element: ExpressionElement): boolean {
  return (
    getPluginName(element.type) === '__SitePlugin' &&
    !namesEqual(element.type, pageComponentType)
  );
}
